export default "__VITE_ASSET__DBRHedyy__";